import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import NavbarHome from "../../../components/ui/NavbarHome";

export default function ResetPasswordFail() {
  const navigate = useNavigate();
  useEffect(() => {
    if (
      localStorage.getItem("swToken") &&
      localStorage.getItem("swToken") != ""
    ) {
      navigate("/Dashboard");
    }
  }, []);
  return (
    <div>
      <NavbarHome />
      <div className="min-h-full relative flex items-center justify-center sm:mt-24 mt-8 sm:px-6 lg:px-8">
        <div className="max-w-xl w-full bg-white p-4 shadow-lg rounded-xl border-2 space-y-8 sm:mx-0 mx-6">
          <div>
            <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
              Reset Password Fail
            </h2>
          </div>
          <div className="rounded-md shadow-sm space-y-4">
            <p>
              What is Lorem Ipsum? Lorem Ipsum is simply dummy text of the
              printing and typesetting industry. Lorem Ipsum has been the
              industry's standard dummy text ever since the 1500s, when an
              unknown
            </p>
          </div>
          <div className="mb-28"></div>
        </div>
      </div>
    </div>
  );
}
